import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'

import style from './ApplyAlert.scss';
import AlertCircleIcon from '../icons/AlertCircle';

const ApplyAlert = ({ description }) => (
  <li className={style.root}>
    <div className={style.iconWrapper}>
      <AlertCircleIcon size={15} fill="#052b52" />
    </div>
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: description }}
    />
  </li>
);

ApplyAlert.propTypes = {
  description: PropTypes.string.isRequired,
};

export default withStyles(style)(ApplyAlert);
